'use client';
/** @jsxImportSource @emotion/react */

import type { ListItemIconProps as MuiListItemIconProps } from '@mui/material/ListItemIcon';

import MuiListItemIcon from '@mui/material/ListItemIcon';
import { useTheme } from '@mui/material/styles';

interface ListItemIconProps extends MuiListItemIconProps {
  color?: MuiListItemIconProps['color'] | 'forceWhite';
}

/**
 * @deprecated Please use `List.ItemAffix` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-list-migration--list-migration-guide Migration guide}
 */
export type { ListItemIconProps };
/**
 * @deprecated Please use `List.ItemAffix` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-list-migration--list-migration-guide Migration guide}
 */
export const ListItemIcon: React.FC<ListItemIconProps> = ({
  color,
  sx = [],
  ...props
}) => {
  const theme = useTheme();
  const resolvedColor =
    color === 'forceWhite'
      ? { color: theme.palette.forceWhite.main }
      : { color: color };
  return (
    <MuiListItemIcon
      {...props}
      sx={[resolvedColor, ...(Array.isArray(sx) ? sx : [sx])]}
    />
  );
};

ListItemIcon.displayName = 'ListItemIcon';
